import React from 'react';
import { useHistory } from 'react-router-dom';
import SendUnlockAccountEmailTemplate from '@rexmas/rexmas-shared/lib/components/templates/login/SendUnlockAccountEmail';
import { useActions, useSimpleState } from '@rexmas/rexmas-shared/lib/utils/hooks';
import { unlockUserAccount as unlockUserAccountAction } from '../../../redux/actions/session';
import rexIcon from '../../../img/rex-logo.svg';
import { pathLanguageCode } from '../../../conf/constants/constants';

function UnlockUserAccount() {
  const history = useHistory();
  const [state, setState] = useSimpleState({
    isLoading: false,
    successfullSendEmail: false,
    isButtonActive: false,
    username: '',
    usernameError: '',
    pathRedirect: `/remuneraciones/${pathLanguageCode}/login`,
  });

  const [unlockUserAccount] = useActions([unlockUserAccountAction]);

  const resetPasswordHandle = () => {
    const { username } = state;
    unlockUserAccount(username, () => null).then((response) => {
      if (response?.mensaje != null) {
        setState({ successfullSendEmail: true });
      } else {
        setState({ isLoading: false });
      }
    });
  };

  const validateData = () => {
    if (state.username.length < 1) {
      setState({ usernameError: 'Escriba 1 caracter o más' });
      return false;
    }
    return true;
  };

  const activedSendButton = () => {
    const isButtonActive = state.password !== '';
    setState({ isButtonActive });
  };

  const handleTextChange = (prop) => (event) => {
    if (['username'].includes(prop)) {
      activedSendButton();
      return setState({
        [`${prop}Error`]: '',
        [prop]: event.target.value,
      });
    }
    return setState({
      [prop]: event.target.value,
    });
  };

  const handleButtonClick = () => {
    if (!validateData()) return;
    setState({ isLoading: true });
    resetPasswordHandle();
  };

  const handleBackButtonClick = () => {
    history.push(`/remuneraciones/${pathLanguageCode}/login`);
  };

  return (
    <SendUnlockAccountEmailTemplate
      username={state.username}
      usernameError={state.usernameError}
      onTextChange={handleTextChange}
      onSubmit={handleButtonClick}
      onBackButtonClick={handleBackButtonClick}
      isButtonActive={state.isButtonActive}
      successfullSendEmail={state.successfullSendEmail}
      isLoading={state.isLoading}
      pathRedirect={state.pathRedirect}
      logo={rexIcon}
      isAdmin
    />
  );
}

export default UnlockUserAccount;
